// extracted by mini-css-extract-plugin
export default {"workflow-button":"Email_workflow-button__dEgG3","email-alias-description":"Email_email-alias-description__8eoaO","loading-value":"Email_loading-value__AFcxo"};